module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/jm-74ccffca23e5a91356deb4060afdd5b9.svg";